export default __webpack_public_path__ + "static/media/virtual-training.07c5f220.jpg";